/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import { pushOneLanguage } from "../../../../middlewares/sysNavigation/SysNavigation";
import { useLanguageContext } from "../../../../context/language/LanguageContext";

import { Modal, Button, Search, Pagination } from "../../component/Component";
import { _PAGE_SIZE_ } from "../../../../middlewares/other/tools";

const addRoute = "/language/add";
const editRoute = "/language/edit";

const Overview = () => {
  const [languageList, setLanguageList] = useState([]);
  const { language, fetchLanguages, count } = useLanguageContext();

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(_PAGE_SIZE_);

  useEffect(() => {
    if (!language) fetchLanguages(page, pageSize);
    setLanguageList(language);
  }, [language]);

  const SearchList = (e) => {
    const key = String(e.target.value).toLowerCase();
    const searchArray = [];
    if (language) {
      language.map((_language_) => {
        if (String(_language_?.name).toLowerCase().includes(key))
          return searchArray.push(_language_);
        return true;
      });
    }
    setLanguageList(searchArray);
    if (key === "") setLanguageList(language);
  };

  return (
    <div className="p-4 lg:p-6 h-full overflow-y-auto bg-gray-50">
      <div className="mx-auto max-w-6xl">
        {/* Header */}
        <div className="mb-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <span className="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-indigo-100 text-indigo-600">
              {/* book icon */}
              <svg viewBox="0 0 24 24" className="h-5 w-5" fill="currentColor" aria-hidden="true">
                <path d="M4 5a3 3 0 0 1 3-3h11a1 1 0 0 1 1 1v16a1 1 0 0 1-1.447.894L15 18.118l-2.553 1.276A1 1 0 0 1 11 18.5V4H7a1 1 0 0 0-1 1v14.5A2.5 2.5 0 0 0 8.5 22H20v-2H8.5a.5.5 0 0 1-.5-.5V5z" />
              </svg>
            </span>
            <div>
              <h1 className="text-xl font-semibold leading-tight text-gray-900">Languages</h1>
              <p className="text-sm text-gray-500">Browse, search, edit, and manage languages.</p>
            </div>
          </div>
          <span className="hidden sm:inline-flex items-center rounded-full bg-gray-100 px-3 py-1 text-xs font-medium text-gray-700">
            Total: {count ?? 0}
          </span>
        </div>

        {/* Search + Add */}
        <div className="grid grid-cols-1 gap-3 sm:grid-cols-3">
          <div className="sm:col-span-2">
            <Search
              props={{
                title: "Language",
                onChange: (e) => SearchList(e),
              }}
            />
          </div>
          <div className="w-full sm:justify-self-end">
            <Link to={addRoute}>
              <Button
                props={{
                  type: "button",
                  title: "Add Language",
                  category: "default",
                  action: "add",
                  onClick: null,
                }}
              />
            </Link>
          </div>
        </div>

        {/* Table card */}
        <div className="mt-5 overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm">
          <div className="overflow-x-auto">
            <table className="w-full text-left text-sm">
              <thead className="sticky top-0 z-10 bg-gray-50/90 backdrop-blur">
                <tr className="text-gray-600">
                  <th className="w-2/3 border-b border-gray-200 px-4 py-3 font-semibold">
                    <div className="inline-flex items-center gap-2">
                      {/* tag icon */}
                      <svg viewBox="0 0 24 24" className="h-4 w-4 text-gray-400" fill="currentColor" aria-hidden="true">
                        <path d="M21 11.5 12.5 3H6a3 3 0 0 0-3 3v6.5L11.5 21a2.1 2.1 0 0 0 3 0l6.5-6.5a2.1 2.1 0 0 0 0-3zM7.5 8A1.5 1.5 0 1 1 9 6.5 1.5 1.5 0 0 1 7.5 8z" />
                      </svg>
                      Name
                    </div>
                  </th>
                  <th className="w-1/3 border-b border-gray-200 px-4 py-3 text-right font-semibold">
                    <div className="inline-flex items-center gap-2">
                      {/* dots icon */}
                      <svg viewBox="0 0 24 24" className="h-4 w-4 text-gray-400" fill="currentColor" aria-hidden="true">
                        <circle cx="5" cy="12" r="2" />
                        <circle cx="12" cy="12" r="2" />
                        <circle cx="19" cy="12" r="2" />
                      </svg>
                      Actions
                    </div>
                  </th>
                </tr>
              </thead>

              <tbody className="divide-y divide-gray-100">
                {language ? (
                  (languageList ?? []).map((_language_) => (
                    <tr key={_language_.language_id} className="odd:bg-white even:bg-gray-50 hover:bg-indigo-50/60 transition-colors">
                      <td className="px-4 py-3 align-middle">
                        <span className="inline-flex items-center rounded-md bg-gray-100 px-2 py-1 text-xs font-medium text-gray-700">
                          {_language_.name}
                        </span>
                      </td>
                      <td className="px-4 py-3 align-middle">
                        <div className="flex justify-end">
                          <ActionButton props={_language_} />
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr className="odd:bg-white even:bg-gray-50">
                    <td className="px-4 py-6 text-gray-400">Loading...</td>
                    <td className="px-4 py-6 text-right text-gray-400">Loading...</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* Pagination */}
        <div className="mt-4">
          <Pagination
            page={page}
            setPage={setPage}
            pageSize={pageSize}
            setPageSize={setPageSize}
            total_items={count}
            callbackFunction={(_page_, _pageSize_) => {
              fetchLanguages(_page_, _pageSize_);
            }}
          />
        </div>
      </div>
    </div>
  );
};

const ActionButton = ({ props }) => {
  const { language, updateLanguageState, deleteLanguage } = useLanguageContext();
  const [showModal, setShowModal] = useState(false);

  const language_id = props.language_id;
  const language_name = props.name;
  const _language_ = props;

  const deleteOneLanguageById = async (id) => {
    const response = await deleteLanguage(id);
    if (response.data.status === 200) {
      if (language) {
        const update = language.filter((l) => l.language_id !== id);
        updateLanguageState(update);
        setShowModal(false);
      }
    }
  };

  return (
    <>
      <Modal
        props={{
          name: language_name,
          showModal,
          setShowModal: () => setShowModal(false),
          delete: () => deleteOneLanguageById(language_id),
        }}
      />

      <div className="flex items-center gap-2">
        <Link to={editRoute}>
          <Button
            props={{
              type: "button",
              title: "Edit",
              category: "blue",
              action: "edit",
              onClick: () => pushOneLanguage(_language_),
            }}
          />
        </Link>
        <Button
          props={{
            type: "button",
            title: "Delete",
            category: "red",
            action: "delete",
            onClick: () => setShowModal(true),
          }}
        />
      </div>
    </>
  );
};

export default Overview;
